import React, { useEffect, useState } from "react";
import Loader from "../../Components/Loader/Loader";
import useAxiosHelper from "../../Common/AxiosHelper";
import { useDispatch, useSelector } from "react-redux";
import { ApiPaths } from "../../Config/ApiPath";
import { setIncomeWallet } from "../../Redux/IncomeWallet";
import { BasicInfo } from "../../Config/BasicInfo";
import { Row } from "react-bootstrap";
import TransferHistory from "../TransferHistory/TransferHistory";

const UtilityWallet = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState("");
  const [amount, setAmount] = useState("");
  const incomeData = useSelector((state) => state.incomeData.incomeWallet);
  const [refresh, setRefresh] = useState(false);

  const profileData = useSelector(
    (state) => state.profileData.userPersonalInfo
  );

  const { AxiosPost, AxiosGet } = useAxiosHelper();

  async function fetchWallets() {
    try {
      const response = await AxiosGet(ApiPaths.getWallets);
      BasicInfo.isDebug && console.log("Wallets==>", response);
      if (response) {
        const walletsData = response.wallets.filter(
          (wallet) => wallet.wallet_type === "wallet"
        );
        dispatch(setIncomeWallet(walletsData));
      }
    } catch (e) {
      BasicInfo.isDebug && console.log(e);
    }
  }
  var x = 0;
  useEffect(() => {
    if (x == 0) {
      fetchWallets();
      x++;
    }
  }, []);
  return (
    <>
      {loading && <Loader />}

      <section className="dashboard">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="">
            <div className="addfundDiv inputPrimary">
              <h1>Utility Wallet</h1>
              <div className="subscriptionWallets">
                <div className="d-flex justify-content-between">
                  <p>Available Balance:</p>
                  {incomeData?.map((x, i) => {
                    return (
                      x?.slug == "main_wallet" && (
                        <p>${parseFloat(x?.value || 0).toFixed(2)}</p>
                      )
                    );
                  })}
                </div>
              </div>

              <label htmlFor="Category">Category</label>
              <select
                className="inputPrimary"
                style={{ borderRadius: "25px", padding: "8px 20px" }}
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <option value="">Select Category</option>
              </select>
              {/* <input
                type="number"
                className="inputPrimary"
                placeholder="Enter Category"
                style={{ borderRadius: "25px", padding: "8px 20px" }}
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              /> */}
              <label htmlFor="Amount">Amount ($)</label>
              <input
                type="number"
                className="inputPrimary"
                placeholder="Enter Amount"
                style={{ borderRadius: "25px", padding: "8px 20px" }}
                // value={amount}
                // onChange={(e) => setAmount(e.target.value)}
              />
              {/* <p className="errorMsg">{amountError}</p> */}
              <button
                className="btnPrimary mt-3"
                // onClick={Withdraw}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
        <Row className="d-flex gap-4"></Row>
        <section>
          <TransferHistory refresh={refresh} />
        </section>
      </section>
    </>
  );
};

export default UtilityWallet;
